import { Box, Card, CardContent, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";

export function TopStories({ itpost, gstpost, ngpost, data }) {
  const navigate = useNavigate();

  const renderStories = (posts) => {
    if (!posts || posts.length === 0) {
      return (
        <div className="col-span-full text-center text-gray-500 text-lg">
          Not Found
        </div>
      );
    }

    const handleViewBlog = (postId, posts) => {
      const data = posts.find((item) => item._id === postId);
      console.log(data);
      navigate(`/blog/${postId}`, {
        replace: true,
        state: { data },
      });
    };

    if (posts.length > 3) {
      posts = posts.slice(0, 3);
    }

    return posts.map((post) => (
      <Button key={post._id} onClick={() => handleViewBlog(post._id, posts)}>
        <Card className="rounded-lg overflow-hidden shadow-md">
          <div className="relative h-48">
            <img
              src={post.image}
              alt={post.title}
              className="object-cover w-full h-full"
            />
          </div>
          <CardContent className="p-4 h-32">
            <h3 className="font-bold text-base sm:text-lg lg:text-xl mb-2 line-clamp-3">
              {post.title}
            </h3>
          </CardContent>
        </Card>
      </Button>
    ));
  };

  const handleclick = (name) => {
    navigate(`/blogcategory/${name}`, {
      replace: true,
      state: { name, data },
    });
  };

  return (
    <>
      <section className="!py-4">
        <div className="flex flex-col md:flex-row justify-between">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold md:mb-6 mb-3 text-gray-800 flex items-center space-x-2">
            <span>Top Articles :</span>
            <div className=" text-[#151C62] flex items-center space-x-1">
              <span>#TaxUpdates-</span>
              <Avatar
                sx={{
                  bgcolor: "#151C62",
                  width: 24,
                  height: 24,
                  fontSize: 12,
                  mt: 1,
                }}
                variant="square"
              >
                NG
              </Avatar>
            </div>
          </h2>

          <Button
            className=" text-[#151C62] text-xs sm:text-base font-semibold  !justify-end"
            onClick={() => handleclick("NG")}
          >
            <span className="text-[#151C62] underline text-xs">View more</span>
          </Button>
        </div>
        <Box className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {renderStories(ngpost)}
        </Box>
      </section>

      <section className="!py-4">
        <div className="flex  flex-col md:flex-row justify-between">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold md:mb-6 mb-3 text-gray-800">
            Top Articles :<span className="text-[#151C62]"> Income Tax</span>
          </h2>
          <Button
            className=" text-[#151C62] text-xs sm:text-base font-semibold !justify-end"
            onClick={() => handleclick("Income Tax")}
          >
            <span className="text-[#151C62] text-xs underline">View more</span>
          </Button>
        </div>
        <Box className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {renderStories(itpost)}
        </Box>
      </section>

      <section className="!py-4">
        <div className="flex  flex-col md:flex-row justify-between">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold md:mb-6 mb-3 text-gray-800">
            Top Articles :<span className="text-[#151C62]"> GST</span>
          </h2>
          <Button
            className=" text-[#151C62] text-xs sm:text-base font-semibold  !justify-end"
            onClick={() => handleclick("GST")}
          >
            <span className="text-[#151C62] underline text-xs">View more</span>
          </Button>
        </div>
        <Box className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {renderStories(gstpost)}
        </Box>
      </section>
    </>
  );
}
